/* eslint-disable vue/attributes-order */
<template>
  <div class="my-4">
    <span class="caption grey--text text--darken-1">Tipo de Anestesia & região anatómica</span>
    <div class="procedure">
    <!-- <v-radio-group multiple v-model="procedures" row> -->
    <v-layout wrap>
      <v-checkbox label="Geral" v-model="showGeneralAnesthesia" />
      <v-checkbox label="Loco Regional" v-model="showLocoRegionalAnesthesia" />
      <v-checkbox label="Sedoanalgesia" v-model="sedoanalgesiaVal" />
      <v-checkbox label="CAM" v-model="camVal" />
      <v-checkbox
        label="Combinada"
        @change="val => setType('combined-anesthesia', val)"
        v-model="selectedCombinedAnesthesia"
      />
    </v-layout>
    <v-select
      v-if="showGeneralAnesthesia"
      :value="generalAnesthesia"
      clearable
      label="Anestesia Geral"
      :items="generalAnesthesiaTypes"
      @input="val => setType('general-anesthesia', val)"
    />
    <!--<v-treeview
      v-if="showLocoRegionalAnesthesia"
      :value="locoRegionalAnesthesia"
      selectable
      :multiple-active="true"
      :items="locoRegionalTree"
      @input="setLocoregional"
    /> -->
    <v-treeview
      v-if="showLocoRegionalAnesthesia"
      :active.sync="selectedLocoRegional"
      :items="locoRegionalTree"
      :multiple-active="true"
      activatable
      :value="locoRegionalAnesthesia"
      active-class="back--text"
      open-on-click
    >
      <template v-slot:label="{ item, active }">
        <v-icon
          style="font-size: 20px"
          v-show="!item.children"
          v-text="active ? 'fas fa-check-square' : 'far fa-square'"
          :class="active ? 'secondary--text' : ''"
        ></v-icon>
        <span v-show="!item.children">{{ item.name }}</span>
        <span v-if="item.children">{{ item.name }}</span>
      </template>
    </v-treeview>
    <v-text-field
      v-if="isPeripheralNerveBlockage"
      :value="peripheralNerveDescription"
      label="Bloqueio de nervo Periférico"
      @change="setPeripheralNerveDescription"
    />
    <div class="mt-4">
    <span class="caption grey--text text--darken-1">Método de Orientação</span>
    <v-select
      class="thin-border"
      v-if="locoRegionalAnesthesia"
      :value="guidance"
      clearable
      :items="guidanceOptions"
      @input="val => setType('guidance', val)"
      solo
    />
    </div>
  </div>
  </div>
</template>

<script>
import { Component, Option } from '../../../models/Specialty'
import { Anesthesiology } from '../../../models/Anesthesiology'
export default {
  props: {
    locoRegionalAnesthesia: { type: [Array], default: () => [] },
    generalAnesthesia: { type: String, default: '' },
    combinedAnesthesia: { type: Boolean, default: false },
    sedoanalgesia: { type: Boolean, default: false },
    cam: { type: Boolean, default: false },
    peripheralNerveDescription: { type: String, default: '' },
    guidance: { type: String, default: '' }
  },
  data() {
    return {
      selectedLocoRegional: [],
      showGeneralAnesthesia: !!this.generalAnesthesia,
      showLocoRegionalAnesthesia:
        this.locoRegionalAnesthesia && this.locoRegionalAnesthesia.length
    }
  },
  created() {
    this.selectedLocoRegional = this.locoRegionalAnesthesia
  },
  computed: {
    selectedCombinedAnesthesia: {
      get() {
        return this.combinedAnesthesia
      },
      set(val) {
        return val
      }
    },
    generalAnesthesiaTypes() {
      return (
        Option.query()
          .where('component', 'general-anesthesia')
          .get() || []
      )
    },
    guidanceOptions: () => {
      return (
        Option.query()
          .where('component', 'anesthesia-guidance')
          .get() || []
      )
    },
    locoRegionalTree() {
      return (
        Anesthesiology.query()
          .with('locoRegionalTree.*')
          .first() || {}
      ).locoRegionalTree
    },
    components() {
      return (
        Component.query()
          .with('options')
          .get() || []
      )
    },
    isPeripheralNerveBlockage() {
      return this.locoRegionalAnesthesia === 'periferal-nerves'
    },
    camVal: {
      get() {
        return this.cam
      },
      set(val) {
        this.setType('cam', val)
      }
    },
    sedoanalgesiaVal: {
      get() {
        return this.sedoanalgesia
      },
      set(val) {
        this.setType('sedoanalgesia', val)
      }
    }
  },
  methods: {
    setType(type, val) {
      this.$emit(`update:${type}`, val)
    },
    setGuidance(guidance) {
      this.$emit('update:guidance', guidance)
    },
    setLocoregional(sites) {
      let value = sites
      if (sites && sites.length === 0) {
        value = undefined
      }
      this.$emit('update:loco-regional-anesthesia', value)
    },
    setPeripheralNerveDescription(val) {
      this.$emit('update:peripheral-nerve-description', val)
    }
  },
  watch: {
    selectedLocoRegional(val) {
      if (val) {
        this.setLocoregional(val)
      }
    },
    showGeneralAnesthesia(val) {
      if (!val) {
        this.setType('general-anesthesia', undefined)
      }
    },
    showLocoRegionalAnesthesia(val) {
      if (!val) {
        this.setType('loco-regional-anesthesia', undefined)
      }
    }
  }
}
</script>

<style scoped>
.procedure {
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  padding: 15px;
}
</style>
